export default{
    user: null,
    date: null,
    showMenu: true,
    isLogged: false,
    error: false,
    errorMessage: '',
    access_token: '',
    token_device: '',

    rutaDocumentosPresupuestos: '',
    rutaDocumentosConfirmaciones: '',
    rutaDocumentosContratos: '',
    rutaDocumentosFacturas: '',

}